import React from "react";

const HashConcept = props => {
  return (
    <div>
      <p className="step-p">
        A valid hash for a blockchain is a hash that meets a certain requirement. For this 
        blockchain, having three zeros at the beginning of the hash is the requirement for a valid hash.
      </p>

      <p className="step-p">
        The number of leading zeros required is the <b>difficulty</b>.
      </p>
    </div>
  );
};

export default HashConcept;



// WEBPACK FOOTER //
// ./src/steps/hash-2/hash-concept.js